import axios from "../config/axios";

export const fetchNotifications = async (params = {}) => {
  try {
    const resp = await axios({
      method: "get",
      url: "/api/notifications",
      params,
    });
    return {
      status: resp.data?.status === true,
      result: resp.data?.result || [],
      unreadCount: resp.data?.unreadCount ?? 0,
      count: resp.data?.count ?? 0,
    };
  } catch (err) {
    return { status: false, result: [], unreadCount: 0 };
  }
};

export const markNotificationRead = async (id) => {
  try {
    const resp = await axios({
      method: "put",
      url: `/api/notifications/${id}/read`,
    });
    return {
      status: resp.data?.status === true,
      unreadCount: resp.data?.unreadCount ?? 0,
    };
  } catch (err) {
    return { status: false };
  }
};

export const markAllNotificationsRead = async () => {
  try {
    const resp = await axios({
      method: "put",
      url: "/api/notifications/read-all",
    });
    return { status: resp.data?.status === true, unreadCount: 0 };
  } catch (err) {
    return { status: false };
  }
};
